module.exports = __webpack_public_path__ + "img/Loader_link.8ce28dc2.svg";